import React from 'react';
import cx from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import Img from 'components/Image';
import Link from 'components/Link';
import hexColoredSmall from "utils/images/hex-colored-small.svg";
import WL from 'constants/whiteLabel';
import gs from 'pages/pages.module.css';
import s from 'pages/homeStyles.module.css'
import style from './partnersMsk.module.css';
import languages from 'constants/languages';

const mskMinerLinks = {
  [languages.EN]: 'https://mskminer.com/en/hiveos/',
  [languages.RU]: 'https://mskminer.com/ru/hiveos/',
}

const Overclock = () => {
  const intl = useIntl();
  const mskMinerLink = mskMinerLinks[intl.locale] || '';

  return (
    <section className={cx(style.root, gs.content, s.hiveosContent, s.alternate)}>
      {WL.showHexImg ? <img alt="" className={cx(s.drop1, s.__beInControl)} src={hexColoredSmall}/> : null}
      <div className={gs.backgroundHeader}>partners</div>
      <div className={cx(gs.wrapper, s.wrapper)}>
        <div className={gs.relative}>
          <div className={style.transfromToRight}>
            <Img className={style.screen} src="msk.png" alt="msk"/>
          </div>
        </div>
        <div className={style.text}>
          <h2><FormattedMessage id="PartnersMsk.poweredBy" defaultMessage="Powered by"/></h2>
          <h2>MSKMINER</h2>
          <p className={gs.subheader}>
            <FormattedMessage id="PartnersMsk.caption1" defaultMessage="Leaders united to give you more"/>
          </p>
          <div>
            <FormattedMessage
              id="PartnersMsk.caption2"
              defaultMessage="Squeeze out max profit from your ASICs with Hiveon ASIC powered by {mskMinerLink}, best ASIC firmware on the market guided by the most popular mining platform."
              values={{ mskMinerLink: <Link external href={mskMinerLink} className={gs.link}>MSKMINER</Link> }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Overclock;
